import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getExerciseRightTypesService } from 'services/analyticsCenter/benefitHistory';
import { ExerciseRightTypeTypes } from 'services/analyticsCenter/benefitHistory/types';
import { getExerciseRightsService } from 'services/analyticsCenter/businessNews';
import { ExerciseRightDataTypes, ExerciseRightParamsTypes } from 'services/analyticsCenter/businessNews/types';

type BenefitHistoryState = {
  exerciseRightTypes : ExerciseRightTypeTypes[];
  exerciseRight?: PaginationData<ExerciseRightDataTypes[]>;
};

const initialState: BenefitHistoryState = {
  exerciseRightTypes: [],
};

export const getExerciseRightTypesAction = createAsyncThunk<
  ExerciseRightTypeTypes[],
  undefined,
  { rejectValue: ErrorResponse }
>(
  'benefitHistoryReducer/getExerciseRightTypes',
  async (_, { rejectWithValue }) => {
    try {
      return await getExerciseRightTypesService();
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  },
);

export const getExerciseRightBenefitAction = createAsyncThunk<
PaginationData<ExerciseRightDataTypes[]>,
  ExerciseRightParamsTypes,
  { rejectValue: ErrorResponse }
>(
  'benefitHistoryReducer/getExerciseRightBenefit',
  async (params: ExerciseRightParamsTypes, { rejectWithValue }) => {
    try {
      return await getExerciseRightsService(params);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  },
);

export const benefitHistorySlice = createSlice({
  name: 'benefitHistoryReducer',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(
      getExerciseRightTypesAction.fulfilled,
      ($state, action) => {
        $state.exerciseRightTypes = action.payload;
      },
    );
    builder.addCase(
      getExerciseRightBenefitAction.fulfilled,
      ($state, action) => {
        $state.exerciseRight = action.payload;
      },
    );
  },
});

export default benefitHistorySlice.reducer;
